jQuery(document).ready(function () {

  $('.headermenuburger_toggle-btn').on('click', function (e) {

    if ($('.headermenuburger_checkbox').attr('checked')) {
      $('.headermenuburger_checkbox').attr('checked', false);
      $(".headermenuburger_menu").removeClass("menu_visible");
      $(".div_modal").removeClass("visible");
      $('html').removeClass("modal_visible");
      $(this).focus();
    } else {
      $('.headermenuburger_checkbox').attr('checked', true);
      $(".headermenuburger_menu").addClass("menu_visible");
      $(".div_modal").addClass("visible");
      $('html').addClass("modal_visible");
    }
    e.preventDefault();
  });

  $('.headermenuburger_accebility_mobile').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass("accesibility");
    $(this).toggleClass('view-accesibility');
  });

  $('.headermenuburger .accesibility a').on('click', function (e) {
    e.preventDefault();
    $('body').toggleClass("accesibility");
    $(this).parent().toggleClass('view-accesibility');
  });

  $('.headermenuburger .account').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_account').addClass("visible");
    $('.div_modal').addClass("visible");
    $('html').addClass("modal_visible");
    setTimeout(function () {
      $('.headermenuburger_account_close').filter(':visible').focus();
    }, 500);
  });

  $('.div_modal').on('click', function () {
    $('.headermenuburger_account').removeClass("visible");
    $(".headermenuburger_menu").removeClass("menu_visible");
    $(".div_modal").removeClass("visible");
    $('html').removeClass("modal_visible");
    $('.headermenuburger_checkbox').attr('checked', false);
  });

  $('.headermenuburger_account_close').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_account').removeClass("visible");
    $('.div_modal').removeClass("visible");
    $('html').removeClass("modal_visible");
    $('.headermenuburger .account a').focus();
  });

  $('.headermenuburger .search').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_search').addClass("visible");
    $('.div_modal_light').addClass("visible");
    setTimeout(function () {
      $('.headermenuburger_search_close').filter(':visible').focus();
    }, 500);
  });

  $('.headermenuburger_search_close').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_search').removeClass("visible");
    $('.div_modal_light').removeClass("visible");
    $('html').removeClass("modal_visible");
    $('header').removeClass("relative");
    $('.headermenuburger .search a').focus();
  });

  $('.forgot-password a').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_account_login').addClass("hide");
    $('.headermenuburger_account_passwordLost').removeClass("hide");
  });

  $('a.button-cancel').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_account_login').removeClass("hide");
    $('.headermenuburger_account_passwordLost').addClass("hide");
    $('.headermenuburger_account_register').addClass("hide");
  });

  $('.headermenuburger_account_createlink_btn').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_account_login').addClass("hide");
    $('.headermenuburger_account_register').removeClass("hide");
  });


  // Fetch all the details element.
  const details = document.querySelectorAll("details.parent");

  // Add the onclick listeners.
  details.forEach((targetDetail) => {
    targetDetail.addEventListener("click", () => {
      // Close all the details that are not targetDetail.
      details.forEach((detail) => {
        if (detail !== targetDetail) {
          detail.removeAttribute("open");
        }
      });
    });
  });

  /* window.addEventListener('focus', function(e){
      console.log(e.target);
  }, true); */

  // Fetch all the detailsChild element.
  const detailsChild = document.querySelectorAll("details.child");

  // Add the onclick listeners.
  detailsChild.forEach((targetDetailChild) => {
    targetDetailChild.addEventListener("click", () => {
      // Close all the details that are not targetDetail.
      detailsChild.forEach((detailChild) => {
        if (detailChild !== targetDetailChild) {
          detailChild.removeAttribute("open");
        }
      });
    });
  });

  /*************** Menu mobile **************/
  $('.headermenuburger_toggle-btn_mobile').on('click', function (e) {
    e.preventDefault();
    if ($('.headermenuburger_checkbox_mobile').attr('checked')) {
      $('.headermenuburger_checkbox_mobile').attr('checked', false);
      $(".headermenuburger_menu_mobile").addClass("close");
      $('html').removeClass("modal_visible");
      $(this).focus()
    } else {
      $('.headermenuburger_checkbox_mobile').attr('checked', true);
      $(".headermenuburger_menu_mobile").removeClass("close");
      $('html').addClass("modal_visible");
    }
  });

  $('.headermenuburger_search_btn_mobile').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_search').addClass("visible");
    $('.div_modal_light').addClass("visible");
    $('html').addClass("modal_visible");
  });

  $('.headermenuburger_account_btn_mobile').on('click', function (e) {
    e.preventDefault();
    $('.headermenuburger_account').addClass("visible");
    $('.div_modal').addClass("visible");
    $('html').addClass("modal_visible");
  });

  $(".headermenuburger_top_btn_mobile").click(function () {
    $("html, body").animate({
      scrollTop: 0
    }, "slow");
    return false;
  });
  /*************** *********** **************/


  // Perform AJAX login/register on form submit
  $('form#login, form#register').on('submit', function (e) {
    if (!$(this).valid()) return false;
    $('p#status', this).show().text(ajax_auth_object.loadingmessage);
    $('p#status').removeAttr('class');
    $('.headermenuburger_account').append( "<div class='loader'></div>" );
    $('.headermenuburger_account').addClass('loading');
    action = 'ajaxlogin';
    username = $('form#login #username').val();
    password = $('form#login #password').val();
    remember = $('form#login #remember').val();
    email = '';
    security = $('form#login #security').val();
    if ($(this).attr('id') == 'register') {
      action = 'ajaxregister';
      username = $('#signonname').val();
      password = $('#signonpassword').val();
      email = $('#email').val();
      security = $('#signonsecurity').val();
    }
    ctrl = $(this);
    $.ajax({
      type: 'POST',
      dataType: 'json',
      url: ajax_auth_object.ajaxurl,
      data: {
        'action': action,
        'username': username,
        'password': password,
        'email': email,
        'security': security
      },
      success: function (data) {
        $('p#status', ctrl).text(data.message);
        $('p#status').addClass(data.type);
        $('.headermenuburger_account').removeClass('loading');
        $('.loader').remove();
        if (data.loggedin == true) {
          document.location.href = ajax_auth_object.redirecturl;
        }
      }
    });
    e.preventDefault();
  });

  // Client side form validation
  if (jQuery("#register").length)
    jQuery("#register").validate({
      rules: {
        password2: {
          equalTo: '#signonpassword'
        },
        email: {
          required: true,
          email: true
        }
      }
    });
  else if (jQuery("#login").length)
    jQuery("#login").validate();
});